import { CalculationsProgressBanner } from "#batteries-included-components/Banners/CalculationsProgressBanner";
import { ImportDataActionStatusWithQueue } from "#batteries-included-components/Banners/ImportDataActionStatus";
import { EMISSIONS_MEASUREMENT_TYPES } from "#routes/emissions/constants";
import {
  CalculationsSummaryPanel,
  CalculationsTablePanel,
} from "#src/batteries-included-components";
import { getImportDataActionQueueKey } from "#src/batteries-included-components/Buttons/ImportDataAction/ImportDataAction.helpers";
import { CalculationsViewFilterArea } from "#src/batteries-included-components/FilterAreas/CalculationsFilterAreas";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { generateDocumentTitle } from "@validereinc/common-components";
import {
  AssetType,
  MeasurementTypeType,
  ResourceDefinitions,
} from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

const importDataActionQueueKey = getImportDataActionQueueKey({
  resource: {
    id: "estimation_method_config",
    description: "",
    label: {
      singular: "Emissions Calculation",
      plural: "Emissions Calculations",
    },
  },
});

export const CalculatorsEmissionsTab = () => {
  const [isDataIngestionEnabled] = useIsFeatureAvailable({
    featureFlagQuery: "core:data_pipeline",
  });

  const [calcsAndRecordsSharedViewConfigStorageKey] = useStorageKey(
    ["view-configuration"],
    "calculations-records-shared"
  );
  const [
    calculationsEmissionsFilterConfigStorageKey,
    calculationsEmissionsTableConfigStorageKey,
    calculationsEmissionsTableStateStorageKey,
  ] = useStorageKey(
    ["filter-configuration", "table-configuration", "table-state"],
    ["calculations", "calculators", "list", "emissions"]
  );
  const [emissionsCalculationJobStorageKey] = useStorageKey(
    ["async-job"],
    "calculations-emissions-bulk-calculate"
  );

  const measurementTypeFilter = ({ quantity }: MeasurementTypeType) =>
    quantity !== "volume";

  return (
    <>
      <Titled
        title={generateDocumentTitle(
          `Emissions ${ResourceDefinitions.calculator_result.label.plural}`
        )}
      >
        {isDataIngestionEnabled ? (
          <ImportDataActionStatusWithQueue
            queueKey={importDataActionQueueKey}
          />
        ) : null}
        <CalculationsProgressBanner
          jobStorageKey={emissionsCalculationJobStorageKey}
        />
        <CalculationsViewFilterArea
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          isPeriodDateRange
        />
        <CalculationsSummaryPanel
          assetType={AssetType.EQUIPMENT}
          defaultMeasurementTypes={EMISSIONS_MEASUREMENT_TYPES}
          measurementTypeFilter={measurementTypeFilter}
          filterConfigStorageKey={calculationsEmissionsFilterConfigStorageKey}
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
        />
        <CalculationsTablePanel
          assetType={AssetType.EQUIPMENT}
          defaultMeasurementTypes={EMISSIONS_MEASUREMENT_TYPES}
          measurementTypeFilter={measurementTypeFilter}
          calculationJobStorageKey={emissionsCalculationJobStorageKey}
          filterConfigStorageKey={calculationsEmissionsFilterConfigStorageKey}
          tableConfigStorageKey={calculationsEmissionsTableConfigStorageKey}
          tableStateStorageKey={calculationsEmissionsTableStateStorageKey}
          viewConfigStorageKey={calcsAndRecordsSharedViewConfigStorageKey}
          showEstimationMethodStatusFilter
        />
      </Titled>
    </>
  );
};
